module.exports = __webpack_public_path__ + "static/media/bg.97c3bf80.jpg";